import AorService from './service';
import {
  DistrictFeature,
  GeoJson,
  GetAreaNameFromGeometryData,
  GetDistrictFromGeometryQueryResponse,
  GetRegulatoryAorLayerData,
} from './types';
import { ResponseStatuses } from '@utils/enums';

export const AorServiceQueryKeys = {
  IS_GEOMETRY_IN_VALID_DISTRICT: 'IS_GEOMETRY_IN_VALID_DISTRICT',
  GET_DISTRICTS_FROM_GEOMETRY: 'GET_DISTRICTS_FROM_GEOMETRY',
};

export class AorQueries {
  public static readonly isGeometryInValidDistrict = async (geometry: GeoJson): Promise<boolean | null> => {
    const response = await AorService.getRegulatoryAorLayer(geometry);

    if (response?.status !== ResponseStatuses.Success) {
      return null;
    }

    const data: GetRegulatoryAorLayerData | null =
      typeof response?.data === 'string'
        ? JSON.parse(response.data)
        : (response?.data as unknown as GetRegulatoryAorLayerData | null);

    return (data?.features?.length ?? 0) > 0;
  };

  public static readonly getDistrictLocationFromGeometry = async (
    geometry: GeoJson
  ): Promise<GetDistrictFromGeometryQueryResponse> => {
    const response = await AorService.getDistrictLocationFromGeometry(geometry);
    const jsonData = JSON.parse(response.data || '');
    const data =
      jsonData?.features?.map((feature: DistrictFeature) => ({
        district: `${feature.attributes.DISTRICT} District`,
        stateCode: feature.attributes.STUSPS,
      })) ?? [];

    return data;
  };

  public static readonly getAreaNameFromGeometry = async (geometry: GeoJson) => {
    const response = await AorService.getAreaNameFromGeometry(geometry);
    const data: GetAreaNameFromGeometryData | null =
      typeof response?.data === 'string'
        ? JSON.parse(response.data)
        : (response?.data as unknown as GetAreaNameFromGeometryData | null);

    return data?.features?.map((feature) => feature.attributes.AREANAME) ?? [];
  };
}
